import { Apply } from '../../models/apply';
import { ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { MdDialog, MdSelectChange } from '@angular/material';
import { JobsOffer } from '../../models/jobs-offer';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { ItemCandidateComponent } from '../item-candidate/item-candidate.component';
import { Observable } from "rxjs";
import { JobOffersService } from '../../services/job-offers.service';
import { ConfigurationService } from '../../services/configuration.service';
import { ReportService } from '../../services/report.service';
import { Constants } from '../constants';

@Component({
  selector: 'app-job-report',
  templateUrl: './job-report.component.html',
  styleUrls: ['./job-report.component.css']
})

export class JobReportComponent implements OnChanges, OnInit{
  job: JobsOffer;
  create: boolean;
  role: string;
  email: string;
  applicants: Apply;
  @Input() nameComponent;
  errorMessage: string;
  reportDescription: string = null;
  loading: boolean = false;
  public STATUS = Constants;
  public step: number;
  public filled: boolean;
  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  constructor(public dialog: MdDialog,
              public dialogRef: MdDialogRef<JobReportComponent>,
              private jobService: JobOffersService,
              private configurationService: ConfigurationService,
              private reportService: ReportService,
              @Inject(MD_DIALOG_DATA) public data: any,
              ) {
  }

  ngOnInit () {
    this.job = this.data.job;
    this.create = this.data.create;

    this.configurationService.configuration$.subscribe(
      response => {
        if (response) {
          this.role = localStorage.getItem('role');
        }
      }
    );
    this.jobService.getOffersApplicantByOfferReport(this.job.id, 1).subscribe(
      data => {
        let applicantss:any = data.applicants;
        let list = [];
        if (this.create){
          applicantss.forEach(element => {
            element.firstname = element.user.firstname;
            element.lastname = element.user.lastname;
            element.photo = element.user.photo;
            element.user_id = element.user.id;
            element.email = element.user.email;
            element.description = '';

            let total;
            let competenceValues = [];
            element.competences.forEach(elementC => {
              total = 0;
              if (elementC.answer) {
                elementC.answer.forEach(elementA => {
                  total = total + elementA.option.percentage;
                });
                this.filled = true;
              } else {
                this.filled = false;
              }
              total = Math.trunc(total / 3);
              const value = total + '%';
              competenceValues.push({name: elementC.title, value: value});
            });

            element.competence = competenceValues;
            list.push(element);

          });
        }else{
          this.reportDescription = this.job.report.moreinfo;
          applicantss.forEach(element => {
            let desc = '';
            this.job.report.selected.forEach(element2 => {
              if (element.user.id === element2.user_id) {
                desc = element2.moreinfo;
              }
            });
            element.firstname = element.user.firstname;
            element.lastname = element.user.lastname;
            element.photo = element.user.photo;
            element.user_id = element.user.id;
            element.email = element.user.email;
            element.description = desc;

            let total;
            let competenceValues = [];
            element.competences.forEach(elementC => {
              total = 0;
              if (elementC.answer) {
                elementC.answer.forEach(elementA => {
                  total = total + elementA.option.percentage;
                });
                this.filled = true;
              } else {
                this.filled = false;
              }
              total = Math.trunc(total / 3);
              const value = total + '%';
              competenceValues.push({name: elementC.title, value: value});
            });

            element.competence = competenceValues;

            list.push(element);
          });
        }

        this.applicants = list;
        this.loading = false;
      },
      error => {
        this.errorMessage = <any>error;
        this.loading = false;
      }
    );
  }



    validEmail () {
      if (this.email != undefined && this.email != '') {
        let a = this.emailRegex.test(this.email);
        return a;
      }
      return true;
    }



  onReport(){
    if(this.create){
      this.onPostReport();
    }else{
      this.onPutReport();
    }
  }

  onPostReport(){
    this.reportService.postReport(this.job.id, this.reportDescription, this.applicants, this.email).subscribe(
      data => {
        this.jobService.getOffersById(this.job.id).subscribe(
          data => {
            this.job = data;
            this.jobService.publish(this.job);
          },
          error => {
            this.errorMessage = <any>error;
          }
        );
        this.dialogRef.close('yes');
      },
      error => {
        this.errorMessage = <any>error;
        this.loading = false;
      }
    );
  }

  onPutReport(){
    this.reportService.putReport(this.job.id, this.reportDescription, this.applicants, this.email).subscribe(
      data => {
        this.jobService.getOffersById(this.job.id).subscribe(
          data => {
            this.job = data;
            this.jobService.publish(this.job);
          },
          error => {
            this.errorMessage = <any>error;
          }
        );
        this.dialogRef.close('yes');
      },
      error => {
        this.errorMessage = <any>error;
        this.loading = false;
      }
    );
  }
  ngOnChanges(changes: SimpleChanges) {
  }

  getPercentage(competence) {
    let competence_apply_id = '';
    let total = 0;
    let value = [];
    let i = competence.length;
    competence.forEach(elementCompetence => {
      elementCompetence.answers.forEach(elementAnswer => {
        if (competence_apply_id == '') {
          competence_apply_id = elementCompetence.competence_apply_id;
        }
        if (competence_apply_id != elementCompetence.competence_apply_id) {
          value.push ({name: competence_apply_id, value: total});
          competence_apply_id = elementCompetence.competence_apply_id;
          total = 0;
        }
        total = total + elementAnswer.option.percentage;
      });
      i--;
    });
    if (i > 0) {
      value.push ({name: competence_apply_id, value: total});
    }
    console.log(value);
    return (value);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/job-report/job-report.component.ts